<h1 *header="'Create Your Account'; d9: '#block-pac-theme-pagetitle h1.title'; let title" class="page-header">{{ title }}</h1>
<form (ngSubmit)="OnSubmit()" [formGroup]="form">
  <fieldset bsMigration [bs3Class]="['panel-default']" class="panel" [disabled]="isSaving">
    <legend bsMigration class="panel-heading">Getting Started</legend>
    <div bsMigration class="panel-body">
      <p bsMigration class="pull-right"><em>Already have an account? <a [routerLink]="['/signup', 'login']"
            [queryParams]="{ destination: loginDestination }" queryParamsHandling="merge">Log in here</a>.</em></p>
      <div [bs4Class]="['mb-2']" class="form-group"
        [class.has-error]="HasError | async" [class.has-success]="HasSuccess | async">
        <label for="input-email">Email Address</label>
        <input type="email" [class.is-invalid]="HasError | async" [class.is-valid]="HasSuccess | async" class="form-control" id="input-email" name="eml_address" required
          placeholder="email address" formControlName="eml_address">
        <p [bs4Class]="['mb-2']" class="help-block">This email address will be used as your username to log in to
          {{settings.site_friendly_url}}.</p>
        <div [bs4Class]="['mt-2']" class="alert alert-danger" *ngIf="eml_address.invalid && (eml_address.dirty || eml_address.touched)">
          <ul>
            <li *ngIf="eml_address.errors['required']">Email address is required.</li>
            <li *ngIf="eml_address.errors['typeMismatch'] || eml_address.errors['email']">The email address is
              invalid.
            </li>
            <li *ngIf="eml_address.errors['emailValidator']" [ngSwitch]="eml_address.errors['emailValidator'].code">
              <ng-container *ngSwitchCase="ResponseCode.EMPTY">
                Email address is required.
              </ng-container>
              <ng-container *ngSwitchCase="ResponseCode.INVALID">
                The email address is invalid.
              </ng-container>
              <ng-container *ngSwitchCase="ResponseCode.ERROR">
                An unexpected error has occurred. {{ eml_address.errors['emailValidator'].error }}
              </ng-container>
              <ng-container *ngSwitchCase="ResponseCode.EXISTING">
                It looks like you may already have an account. <a
                  [routerLink]="['/signup/login', { email : eml_address.value }]"
                  [queryParams]="{ destination: loginDestination }" queryParamsHandling="merge">Log in with your email
                  address and password</a>.
              </ng-container>
            </li>
          </ul>
        </div>
      </div>
      <p class="text-muted"><small><em>By creating an account with {{settings.pac_base_asn_code}}, you are agreeing to
            our <a href="/terms-use" target="_blank" [appColorbox]="{ width: 800, height: 600 }">Terms of Use</a>, and
            to receive email from {{settings.pac_base_asn_code}} about member benefits. You can unsubscribe from email
            at any time.</em></small></p>
      <button type="submit" class="btn btn-primary btn-lg" [disabled]="!form.valid">Get Started</button>
    </div>
  </fieldset>
</form>
